import { Component } from "@angular/core";

@Component({
	selector: "mat-col",
	templateUrl: "./mat-col.component.html",
	standalone: true,
})
export class MatColComponent {}
